<div class="events-page">
  <!-- Banner -->
  <div class="info-banner" *ngIf="isDirecteur() || isFormateur() || isParent()">
    <div class="banner-icon"><i class="fas fa-calendar-star"></i></div>
    <div class="banner-text">
      <h5 *ngIf="isDirecteur()">{{ 'EVENTS.BANNER_TITLE_DIRECTOR' | translate }}</h5>
      <h5 *ngIf="isFormateur()">{{ 'EVENTS.BANNER_TITLE_EDUCATOR' | translate }}</h5>
      <h5 *ngIf="isParent()">{{ 'EVENTS.BANNER_TITLE_PARENT' | translate }}</h5>
      <p *ngIf="isDirecteur()">{{ 'EVENTS.BANNER_TEXT_DIRECTOR' | translate }}</p>
      <p *ngIf="isFormateur()">{{ 'EVENTS.BANNER_TEXT_EDUCATOR' | translate }}</p>
      <p *ngIf="isParent()">{{ 'EVENTS.BANNER_TEXT_PARENT' | translate }}</p>
    </div>
  </div>

  <div class="events-layout">
    <!-- LEFT: Calendar -->
    <div class="calendar-panel">
      <div class="calendar-card">
        <!-- Month Header -->
        <div class="cal-header">
          <button class="cal-nav" (click)="goToPreviousMonth()"><i class="fas fa-chevron-left"></i></button>
          <h3 class="cal-month">{{ currentMonth }} {{ currentYear }}</h3>
          <button class="cal-nav" (click)="goToNextMonth()"><i class="fas fa-chevron-right"></i></button>
        </div>

        <!-- Weekdays -->
        <div class="cal-weekdays">
          <div *ngFor="let day of weekDays" class="cal-weekday">{{ day }}</div>
        </div>

        <!-- Days Grid -->
        <div class="cal-days">
          <div *ngFor="let day of daysInMonth; let i = index" class="cal-day"
            [class.other-month]="day.isPrevMonth || day.isNextMonth"
            [class.today]="day.isToday"
            [class.selected]="day.date === selectedDay?.date && !day.isPrevMonth && !day.isNextMonth"
            [class.has-event]="day.hasEvent"
            (click)="selectDay(day)">
            <span class="day-num">{{ day.date }}</span>
            <span class="event-dot" *ngIf="day.hasEvent"></span>
          </div>
        </div>

        <!-- Bottom Bar -->
        <div class="cal-footer">
          <div class="cal-goto">
            <input type="text" [placeholder]="'EVENTS.GOTO_PLACEHOLDER' | translate" [(ngModel)]="inputDate" class="cal-goto-input" />
            <button class="cal-goto-btn" (click)="goToDate()">{{ 'EVENTS.GOTO_BTN' | translate }}</button>
          </div>
          <button class="cal-today-btn" (click)="goToToday()">{{ 'EVENTS.TODAY_BTN' | translate }}</button>
        </div>
      </div>
    </div>

    <!-- RIGHT: Events -->
    <div class="events-panel">
      <!-- Selected Day Header -->
      <div class="day-header">
        <div class="day-header-info">
          <h2 class="day-name">{{ selectedDayName }}</h2>
          <span class="day-date">{{ selectedFullDate }}</span>
        </div>
        <div class="day-header-actions">
          <button class="view-all-btn" (click)="toggleAllEvents()" title="Voir tous les événements">
            <i class="fas fa-list-ul"></i>
          </button>
          <button class="add-event-btn" (click)="toggleAddEvent()"
            *ngIf="(isDirecteur() || isFormateur()) && selectedDayEvents?.length === 0">
            <i class="fas fa-plus"></i>
          </button>
        </div>
      </div>

      <!-- Events List -->
      <div class="events-list">
        <div *ngFor="let event of selectedDayEvents" class="event-card" (click)="openEventPopup(event)">
          <div class="event-card-accent"></div>
          <div class="event-card-body">
            <div class="event-card-icon"><i class="fas fa-calendar-check"></i></div>
            <div class="event-card-info">
              <h4 class="event-card-title">{{ event.titre }}</h4>
              <p class="event-card-desc" *ngIf="event.description">{{ event.description | slice:0:60 }}{{ event.description.length > 60 ? '...' : '' }}</p>
            </div>
            <div class="event-card-arrow"><i class="fas fa-chevron-right"></i></div>
          </div>
        </div>

        <!-- Empty State -->
        <div class="empty-state" *ngIf="selectedDayEvents.length === 0">
          <div class="empty-icon"><i class="fas fa-calendar-day"></i></div>
          <h4>{{ 'EVENTS.NO_EVENT' | translate }}</h4>
          <p *ngIf="isDirecteur() || isFormateur()">Cliquez sur + pour ajouter un événement</p>
        </div>
      </div>

      <!-- Add Event Form (Glassmorphism) -->
      <div class="glass-overlay" *ngIf="isAddEventVisible" (click)="toggleAddEvent()">
        <div class="glass-event-card" (click)="$event.stopPropagation()">
          <div class="glass-event-header">
            <div class="glass-event-icon"><i class="fas fa-calendar-plus"></i></div>
            <h5>{{ isEditMode ? ('EVENTS.ADD_FORM.TITLE_EDIT' | translate) : ('EVENTS.ADD_FORM.TITLE_ADD' | translate) }}</h5>
            <button class="glass-event-close" (click)="toggleAddEvent()"><i class="fas fa-times"></i></button>
          </div>
          <div class="glass-event-body">
            <div class="glass-field">
              <label>{{ 'EVENTS.ADD_FORM.NAME_PLACEHOLDER' | translate }}</label>
              <input type="text" [(ngModel)]="newEvent.name" class="glass-input" />
            </div>
            <div class="glass-field">
              <label>{{ 'EVENTS.ADD_FORM.DESCRIPTION_PLACEHOLDER' | translate }}</label>
              <input type="text" [(ngModel)]="newEvent.description" class="glass-input" />
            </div>
            <div class="glass-field">
              <label class="glass-file-label">
                <i class="fas fa-image"></i> {{ 'EVENTS.ADD_FORM.IMAGE_LABEL' | translate }}
                <input type="file" (change)="onImageSelected($event)" class="glass-file-input" />
              </label>
            </div>
            <div class="glass-image-preview" *ngIf="selectedImage">
              <img [src]="imagePreviewUrl" alt="Preview" />
            </div>
          </div>
          <div class="glass-event-footer">
            <button class="glass-btn glass-btn--ghost" (click)="toggleAddEvent()">{{ 'EVENTS.ADD_FORM.CANCEL_BTN' | translate }}</button>
            <button class="glass-btn glass-btn--primary" (click)="checkBeforeSaveEvent()">
              <i class="fas fa-check me-2"></i>
              {{ isEditMode ? ('EVENTS.ADD_FORM.EDIT_BTN' | translate) : ('EVENTS.ADD_FORM.ADD_BTN' | translate) }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Event Detail Modal (Glassmorphism) -->
  <div class="glass-overlay" *ngIf="isPopupVisible" (click)="closePopup()">
    <div class="glass-detail-card" (click)="$event.stopPropagation()">
      <button class="glass-detail-close" (click)="closePopup()"><i class="fas fa-times"></i></button>

      <!-- Event Photo -->
      <div class="glass-detail-photo" *ngIf="selectedEvent?.photoUrl">
        <img [src]="selectedEvent?.photoUrl" [alt]="selectedEvent?.titre" />
      </div>

      <!-- Event Info -->
      <div class="glass-detail-body">
        <h3 class="glass-detail-title">{{ selectedEvent?.titre }}</h3>
        <div class="glass-detail-meta">
          <span class="meta-item"><i class="fas fa-calendar"></i> {{ selectedFullDate }}</span>
          <span class="meta-item" *ngIf="selectedEvent?.userNom">
            <i class="fas fa-user"></i> {{ selectedEvent?.userPrenom }} {{ selectedEvent?.userNom }}
          </span>
        </div>
        <p class="glass-detail-desc">{{ selectedEvent?.description }}</p>

        <!-- Creator -->
        <div class="glass-detail-creator" *ngIf="selectedEvent?.userId">
          <img *ngIf="selectedEvent?.userPhotoUrl" [src]="selectedEvent?.userPhotoUrl" class="creator-avatar" />
          <div class="creator-info">
            <span class="creator-label">{{ 'EVENTS.POPUP.FIELD_CREATED_BY' | translate }}</span>
            <span class="creator-name">{{ selectedEvent?.userPrenom }} {{ selectedEvent?.userNom }}</span>
          </div>
        </div>
      </div>

      <!-- Actions -->
      <div class="glass-detail-actions" *ngIf="canDeleteEvent()">
        <button class="glass-btn glass-btn--danger" (click)="confirmDeleteEvent()">
          <i class="fas fa-trash me-2"></i> {{ 'EVENTS.POPUP.DELETE_BTN' | translate }}
        </button>
      </div>
    </div>
  </div>

  <!-- All Events Modal -->
  <div class="glass-overlay" *ngIf="showAllEvents" (click)="toggleAllEvents()">
    <div class="glass-all-events-card" (click)="$event.stopPropagation()">
      <div class="glass-all-events-header">
        <div class="glass-all-events-icon"><i class="fas fa-calendar-alt"></i></div>
        <h5>Tous les événements</h5>
        <span class="events-count-badge">{{ allEventsList.length }}</span>
        <button class="glass-all-events-close" (click)="toggleAllEvents()"><i class="fas fa-times"></i></button>
      </div>
      <div class="glass-all-events-body">
        <div *ngIf="allEventsList.length === 0" class="empty-state">
          <div class="empty-icon"><i class="fas fa-calendar-day"></i></div>
          <h4>Aucun événement</h4>
        </div>
        <div *ngFor="let group of allEventsGrouped" class="events-group">
          <div class="events-group-date">
            <i class="fas fa-calendar-day"></i> {{ group.dateFormatted }}
          </div>
          <div *ngFor="let event of group.events" class="all-event-item" (click)="openEventFromAll(event)">
            <div class="all-event-dot"></div>
            <div class="all-event-info">
              <h4>{{ event.titre }}</h4>
              <p *ngIf="event.description">{{ event.description | slice:0:80 }}{{ event.description.length > 80 ? '...' : '' }}</p>
            </div>
            <i class="fas fa-chevron-right all-event-arrow"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
